import z from "zod";

import { useAuthStore } from "~/stores";
import { refreshToken } from "../authentication";

// refresh token was based on this article
// https://dev.to/franciscomendes10866/how-to-use-axios-interceptors-b7d

export const refreshTokenInvalidSchema = z.object({
  error: z.object({
    code: z.literal("invalid_refresh_token"),
    message: z.string(),
  }),
});

export const refreshTokenFn = async (): Promise<boolean> => {
  try {
    const currentRefreshToken = useAuthStore.getState().refreshToken;

    if (!currentRefreshToken) {
      useAuthStore.getState().clearStore();
      return false;
    }

    const response = await refreshToken(currentRefreshToken);
    const { data: tokenData } = response;

    if (tokenData.accessToken && tokenData.refreshToken) {
      useAuthStore
        .getState()
        .setTokens(tokenData.accessToken, tokenData.refreshToken);

      return true;
    }

    return false;
  } catch {
    return false;
  }
};
